import Button from "app/components/button/button";
import CircleLoader from "app/components/loader/CircleLoader";
import { FC, useState } from "react";
import ReferralModal from "../referral-modal/referral-modal";
import styles from "./refferal-card.module.scss";

interface RefferalCardProps {
  refferals?: number;
  isLoadingRefs: boolean;
}

const ReferralCard: FC<RefferalCardProps> = ({ refferals, isLoadingRefs }) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  return (
    <div className={styles.referralCard}>
      <div className={styles.header}>
        <span>My referrals</span>
        {isLoadingRefs ? (
          <CircleLoader isLoading={isLoadingRefs} />
        ) : (
          <span>{refferals}</span>
        )}
      </div>
      <Button
        variant="pink"
        className={styles.inviteButton}
        onClick={handleOpenModal}
      >
        INVITE MORE
      </Button>
      <p className={styles.description}>and get 20% Karma from each referral</p>

      <ReferralModal isOpen={isModalOpen} onClose={handleCloseModal} />
    </div>
  );
};

export default ReferralCard;
